export const SET_SITES = 'SET_SITES';
export const setSitesAction = (sites) => ({
  type: SET_SITES,
  payload: sites,
});
